<clr-modal
  [clrModalOpen]="open"
  (clrModalOpenChange)="onOpenChange($event)"
  [clrModalSize]="'lg'"
>
  <h3 class="modal-title">{{ title }}</h3>
  <div class="modal-body">
    <p *ngIf="subtitle" class="dicom-header-subtitle">{{ subtitle }}</p>

    <div *ngIf="loading" class="dicom-header-loading">
      <span class="spinner spinner-inline"></span>
      Loading DICOM header&hellip;
    </div>

    <ng-container *ngIf="!loading">
      <input
        class="clr-input dicom-header-filter"
        type="text"
        placeholder="Filter by tag, name, or value&hellip;"
        [(ngModel)]="filter"
      />
      <div class="dicom-header-table-scroll">
        <table class="table table-compact">
          <thead>
            <tr>
              <th class="left">Tag</th>
              <th class="left">VR</th>
              <th class="left">Name</th>
              <th class="left">Value</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of filteredTags">
              <td class="left dicom-header-mono">{{ t.tag }}</td>
              <td class="left dicom-header-mono">{{ t.vr }}</td>
              <td class="left">{{ t.name }}</td>
              <td class="left">{{ t.value }}</td>
            </tr>
          </tbody>
        </table>
        <p *ngIf="filteredTags.length === 0" class="dicom-header-empty">
          No matching tags.
        </p>
      </div>
    </ng-container>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="onOpenChange(false)">
      Close
    </button>
  </div>
</clr-modal>
